<div *ngIf="CurrentSection">        
    <h1 class="form-title">{{ CurrentSection.name }}</h1>
    <p *ngIf="CurrentSection.infotext" class="form-subtitle" [innerHTMLBypassXSS]="GetSectionInfoText(CurrentSection)"></p>
</div>